import { render, staticRenderFns } from "./panels.vue?vue&type=template&id=4ebf65bf&scoped=true"
import script from "./panels.vue?vue&type=script&lang=js"
export * from "./panels.vue?vue&type=script&lang=js"
import style0 from "./panels.vue?vue&type=style&index=0&id=4ebf65bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebf65bf",
  null
  
)

export default component.exports